const state = {
  currentList: {
    name: "",
    description: "",
    address: {
      company: "",
      city: "",
      line1: "",
      line2: "",
      "postal-code": "",
      province: "",
      "street-direction": "",
      "street-name": "",
      "street-number": "",
      "unit-number": ""
    },
    imported: false,
    clientProfiles: null,
    applications: null,
    withCoapps: null,
    agentsToImportFrom: [],
    importedList: [],
    csvArray: [],
    manually: null,
    segmentedLists: {},
    listId: "",
    updatedAt: "",
    emailCount: 0,
    list: [],
    segments: [],
    offset: 0,
    limit: 10,
    searchString: "",
    referrerList: null
  },
  campaigns: {
    byId: {},
    allIds: []
  },
  automationCriteria: [],
  currentEmail: {
    emailId: "",
    email: "",
    verified: false,
    updatedAt: ""
  },
  marketingEmails: {
    byId: {},
    allIds: []
  },
  lists: {
    byId: {},
    allIds: []
  },
  segments: [],
  segmentsTranslationMap: {}
};
export default state;